import sessionStore from './session.store';

export default { sessionStore };
